import bookingRules from './booking-rules.json';
import bookings from './bookings.json';
import common from './common.json';
import employees from './employees.json';
import spaceGroups from './space-groups.json';

export default {
  common,
  employees,
  bookingRules,
  spaceGroups,
  bookings,
};
